"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOMATION_BLOCK_CONFIG_DEFAULTS = exports.AUTOMATION_BLOCK_STATUS_TRACKING_DEFAULTS = exports.AUTOMATION_BLOCK_TRIGGER_DEFAULTS = exports.AUTOMATION_BLOCK_BATCH_DEFAULTS = void 0;
exports.automationBlockConfigDefaults = automationBlockConfigDefaults;
exports.withAutomationBlockDefaults = withAutomationBlockDefaults;
const input_1 = require("./input");
/**
 * The values an automation block starts with. A block keeps a field only once
 * it was set: the editor sets them all, a block the server creates (MCP, AI,
 * App install) holds just the fields it was given. Whoever reads a stored
 * block fills the rest from here, so editor and server read the same block.
 */
exports.AUTOMATION_BLOCK_BATCH_DEFAULTS = {
    batchSize: 1,
    sendAsArray: false,
    retry: {
        enabled: false,
        maxAttempts: 3,
        initialDelayMs: 1000,
        backoffMultiplier: 2,
        maxDelayMs: 30000,
    },
    onFailure: 'stop',
};
/** Manual and switched off, until a trigger is chosen. */
exports.AUTOMATION_BLOCK_TRIGGER_DEFAULTS = {
    type: 'manual',
    enabled: false,
    cronPreset: 'every_hour',
    debounceMs: 5000,
};
/**
 * Off, and when switched on a new select column „Status“: a run sets its
 * rows to the pending value when it starts, then to the success or error
 * value.
 */
exports.AUTOMATION_BLOCK_STATUS_TRACKING_DEFAULTS = {
    enabled: false,
    mode: 'status_column',
    columnId: null,
    createColumn: { name: 'Status' },
    standardOptions: ['Pending', 'Done', 'Error'],
    pendingValue: 'Pending',
    successValue: 'Done',
    errorValue: 'Error',
};
/**
 * The configuration fields of a new block and what each holds before it is
 * set; every call gives its own copy. Empty lists take any item type.
 */
function automationBlockConfigDefaults() {
    return {
        executionKind: 'workflow',
        titleMode: 'auto',
        sourceTableId: null,
        sourceTableName: null,
        sourceDocId: null,
        filterGroup: {
            type: 'group',
            op: 'and',
            conditions: [],
        },
        selectedColumns: [],
        inputMappings: [],
        inputTables: [],
        inputOrder: structuredClone(input_1.DEFAULT_INPUT_ORDER),
        workflowId: null,
        workflowName: null,
        outputMode: 'update_source',
        outputTables: [],
        outputMappings: [],
        matchConfigs: [],
        batchConfig: structuredClone(exports.AUTOMATION_BLOCK_BATCH_DEFAULTS),
        triggerConfig: structuredClone(exports.AUTOMATION_BLOCK_TRIGGER_DEFAULTS),
        statusTracking: structuredClone(exports.AUTOMATION_BLOCK_STATUS_TRACKING_DEFAULTS),
    };
}
/** The configuration fields of a block and what each holds before it is set. */
exports.AUTOMATION_BLOCK_CONFIG_DEFAULTS = automationBlockConfigDefaults();
function isFields(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
/** A field that is set keeps its value; an object that is set fills only what it lacks. */
function filled(defaults, value) {
    if (value === undefined)
        return structuredClone(defaults);
    if (!isFields(defaults) || !isFields(value))
        return value;
    const result = { ...value };
    for (const [key, fallback] of Object.entries(defaults)) {
        result[key] = filled(fallback, value[key]);
    }
    return result;
}
/**
 * The configuration of a stored block as the editor reads it: every field it
 * never set holds its default, a field it set stays as it is, also inside the
 * batch, trigger and status tracking settings. Fields of no configuration
 * (title, position, run state) pass through unchanged.
 */
function withAutomationBlockDefaults(stored) {
    const result = { ...stored };
    for (const [key, fallback] of Object.entries(exports.AUTOMATION_BLOCK_CONFIG_DEFAULTS)) {
        result[key] = filled(fallback, stored[key]);
    }
    return result;
}
//# sourceMappingURL=block-defaults.js.map